import { render } from "./HeadingField.vue?vue&type=template&id=e19b3de0"
import script from "./HeadingField.vue?vue&type=script&lang=js"
export * from "./HeadingField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/viktor/Desktop/projects/u2c/x5-group/mission-accomplished/backend/project/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeadingField.vue"]])

export default __exports__